import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_93V00kUUTaZJMeta } from "/app/pages/kurse/[slug].vue?macro=true";
import { default as indexosrduuDtUjMeta } from "/app/pages/kurse/index.vue?macro=true";
import { default as success6XXWtCnPw0Meta } from "/app/pages/oauth/success.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "kurse-slug",
    path: "/kurse/:slug()",
    component: () => import("/app/pages/kurse/[slug].vue")
  },
  {
    name: "kurse",
    path: "/kurse",
    component: () => import("/app/pages/kurse/index.vue")
  },
  {
    name: "oauth-success",
    path: "/oauth/success",
    component: () => import("/app/pages/oauth/success.vue")
  }
]